module.exports = {
	"config": {
		"linkPrefix": "/cacp-contracts",
		"compiler": "0.4.7-develop.2016.12.14+commit.f8fe6e4f.Darwin.appleclang",
		"name": "@digix/cacp-contracts",
		"license": "BSD-3-Clause",
		"version": "0.0.2",
		"description": "Contract Access Control",
		"author": "DigixGlobal",
		"buildTime": "2016-12-27T18:29:28.872Z",
		"target": "scripts/doxity",
		"src": "contracts/*",
		"dir": "pages/docs",
		"source": "https://github.com/DigixGlobal/doxity-gatsby-starter-project/archive/37f63a26c2664c31f4463a49af939ddb6e2181e7.tar.gz",
		"out": "docs",
		"interaction": {
			"network": "2",
			"providerUrl": "https://morden.infura.io/ftFX2a6rGHbiA45c6m0r"
		}
	},
	"relativePath": "",
	"pages": [
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "",
				"stem": "_template",
				"path": "_template.jsx",
				"absolute": "/Users/aeufemio/projects/digixglobal/contracts/cacp/scripts/doxity/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "_template.jsx",
			"templatePath": "//",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "_template.jsx",
				"ext": "jsx",
				"name": "_template",
				"extname": ".jsx",
				"basename": "_template.jsx",
				"dirname": "docs",
				"stem": "_template",
				"path": "docs/_template.jsx",
				"absolute": "/Users/aeufemio/projects/digixglobal/contracts/cacp/scripts/doxity/docs/_template.jsx",
				"isAbsolute": false
			},
			"requirePath": "docs/_template.jsx",
			"templatePath": "/docs/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ACConditions.json",
				"ext": "json",
				"name": "ACConditions",
				"extname": ".json",
				"basename": "ACConditions.json",
				"dirname": "docs",
				"stem": "ACConditions",
				"path": "docs/ACConditions.json",
				"absolute": "/Users/aeufemio/projects/digixglobal/contracts/cacp/scripts/doxity/docs/ACConditions.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ACConditions.json",
			"path": "/docs/ACConditions/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ACDates.json",
				"ext": "json",
				"name": "ACDates",
				"extname": ".json",
				"basename": "ACDates.json",
				"dirname": "docs",
				"stem": "ACDates",
				"path": "docs/ACDates.json",
				"absolute": "/Users/aeufemio/projects/digixglobal/contracts/cacp/scripts/doxity/docs/ACDates.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ACDates.json",
			"path": "/docs/ACDates/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ACGroups.json",
				"ext": "json",
				"name": "ACGroups",
				"extname": ".json",
				"basename": "ACGroups.json",
				"dirname": "docs",
				"stem": "ACGroups",
				"path": "docs/ACGroups.json",
				"absolute": "/Users/aeufemio/projects/digixglobal/contracts/cacp/scripts/doxity/docs/ACGroups.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ACGroups.json",
			"path": "/docs/ACGroups/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ACOwned.json",
				"ext": "json",
				"name": "ACOwned",
				"extname": ".json",
				"basename": "ACOwned.json",
				"dirname": "docs",
				"stem": "ACOwned",
				"path": "docs/ACOwned.json",
				"absolute": "/Users/aeufemio/projects/digixglobal/contracts/cacp/scripts/doxity/docs/ACOwned.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ACOwned.json",
			"path": "/docs/ACOwned/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ACSimpleMutex.json",
				"ext": "json",
				"name": "ACSimpleMutex",
				"extname": ".json",
				"basename": "ACSimpleMutex.json",
				"dirname": "docs",
				"stem": "ACSimpleMutex",
				"path": "docs/ACSimpleMutex.json",
				"absolute": "/Users/aeufemio/projects/digixglobal/contracts/cacp/scripts/doxity/docs/ACSimpleMutex.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ACSimpleMutex.json",
			"path": "/docs/ACSimpleMutex/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ACState.json",
				"ext": "json",
				"name": "ACState",
				"extname": ".json",
				"basename": "ACState.json",
				"dirname": "docs",
				"stem": "ACState",
				"path": "docs/ACState.json",
				"absolute": "/Users/aeufemio/projects/digixglobal/contracts/cacp/scripts/doxity/docs/ACState.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ACState.json",
			"path": "/docs/ACState/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ACUserLevel.json",
				"ext": "json",
				"name": "ACUserLevel",
				"extname": ".json",
				"basename": "ACUserLevel.json",
				"dirname": "docs",
				"stem": "ACUserLevel",
				"path": "docs/ACUserLevel.json",
				"absolute": "/Users/aeufemio/projects/digixglobal/contracts/cacp/scripts/doxity/docs/ACUserLevel.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ACUserLevel.json",
			"path": "/docs/ACUserLevel/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ACUserMutex.json",
				"ext": "json",
				"name": "ACUserMutex",
				"extname": ".json",
				"basename": "ACUserMutex.json",
				"dirname": "docs",
				"stem": "ACUserMutex",
				"path": "docs/ACUserMutex.json",
				"absolute": "/Users/aeufemio/projects/digixglobal/contracts/cacp/scripts/doxity/docs/ACUserMutex.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ACUserMutex.json",
			"path": "/docs/ACUserMutex/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Constants.json",
				"ext": "json",
				"name": "Constants",
				"extname": ".json",
				"basename": "Constants.json",
				"dirname": "docs",
				"stem": "Constants",
				"path": "docs/Constants.json",
				"absolute": "/Users/aeufemio/projects/digixglobal/contracts/cacp/scripts/doxity/docs/Constants.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Constants.json",
			"path": "/docs/Constants/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ContractResolver.json",
				"ext": "json",
				"name": "ContractResolver",
				"extname": ".json",
				"basename": "ContractResolver.json",
				"dirname": "docs",
				"stem": "ContractResolver",
				"path": "docs/ContractResolver.json",
				"absolute": "/Users/aeufemio/projects/digixglobal/contracts/cacp/scripts/doxity/docs/ContractResolver.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ContractResolver.json",
			"path": "/docs/ContractResolver/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "Migrations.json",
				"ext": "json",
				"name": "Migrations",
				"extname": ".json",
				"basename": "Migrations.json",
				"dirname": "docs",
				"stem": "Migrations",
				"path": "docs/Migrations.json",
				"absolute": "/Users/aeufemio/projects/digixglobal/contracts/cacp/scripts/doxity/docs/Migrations.json",
				"isAbsolute": false
			},
			"requirePath": "docs/Migrations.json",
			"path": "/docs/Migrations/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "docs",
				"base": "ResolverClient.json",
				"ext": "json",
				"name": "ResolverClient",
				"extname": ".json",
				"basename": "ResolverClient.json",
				"dirname": "docs",
				"stem": "ResolverClient",
				"path": "docs/ResolverClient.json",
				"absolute": "/Users/aeufemio/projects/digixglobal/contracts/cacp/scripts/doxity/docs/ResolverClient.json",
				"isAbsolute": false
			},
			"requirePath": "docs/ResolverClient.json",
			"path": "/docs/ResolverClient/",
			"data": {}
		},
		{
			"file": {
				"root": "",
				"dir": "",
				"base": "index.md",
				"ext": "md",
				"name": "index",
				"extname": ".md",
				"basename": "index.md",
				"dirname": "",
				"stem": "index",
				"path": "index.md",
				"absolute": "/Users/aeufemio/projects/digixglobal/contracts/cacp/scripts/doxity/index.md",
				"isAbsolute": false
			},
			"requirePath": "index.md",
			"path": "/",
			"data": {}
		}
	]
}


//////////////////
// WEBPACK FOOTER
// ../config.toml
// module id = 379
// module chunks = 0